const RecordLink = ({ record, tenantID, onOpen }) => {
  return (
    <a
      href={`/clouds/${tenantID}/records/${record?._ModuleAPIName}/details/${record?.id}/Summary`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onOpen();
      }}
      className="text-truncate"
    >
      {record?._RecordName || "(No Name)"}
    </a>
  );
};

export default RecordLink;
